import 'waypoints/lib/noframework.waypoints.min.js';

class ViewportVisible {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.class = self.elem.getAttribute('data-viewport-visible-class');
        self.offset = self.elem.getAttribute('data-viewport-visible-offset');
    }

    init() {
        let self = this;

        const waypoint = new Waypoint({
            element: self.elem,
            handler: function(direction) {
                if(direction === 'down') {
                    self.class.trim().split(',').forEach(className => {
                        self.elem.classList.add(className);
                    });
                }
            },
            offset: self.offset ?? '95%'
        });
    }
}

export default ViewportVisible;
